import { ChannelGrid } from "@/components/ChannelGrid";
import { LiveBadge } from "@/components/Equalizer";

export default function Radio() {
  return (
    <div data-testid="radio-page" className="mx-auto max-w-[1400px] px-4 py-16 md:px-8">
      <LiveBadge label="RARA PERLA RADIO" />
      <h1 className="mt-5 font-heading text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">Canales temáticos 24/7</h1>
      <p className="mt-4 max-w-xl text-slate-400">Cada canal suena en bucle aleatorio con canciones aprobadas por curadores. Pulsa play y sigue navegando: la música no se corta.</p>
      <div className="mt-12"><ChannelGrid /></div>
    </div>
  );
}
